import type { ReactNode } from 'react';

import type { TColumnsElement } from '@shared/dream-components';
import { ColumnsElement } from '@shared/dream-components';

interface Props {
  node: TColumnsElement;
  children: ReactNode | ReactNode[];
}

const Columns = ({ node, children }: Props) => {
  return <ColumnsElement element={node}>{children}</ColumnsElement>;
};

export default Columns;
